import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=3e7c73a6&scoped=true&"
import script from "./Button.vue?vue&type=script&setup=true&lang=js&"
export * from "./Button.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Button.vue?vue&type=style&index=0&id=3e7c73a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7c73a6",
  null
  
)

export default component.exports
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QCardSection,QBtn});
